import React from 'react'
import { useI18n } from '../../i18n/I18nContext'
import { workerService } from '../../services/worker'
import { WorkerExternalJobBank } from './worker/WorkerExternalJobBank'

export const PersonalJobBankWorkspace:React.FC=()=>{
  const {t}=useI18n()
  return <section className="panel workspace-panel stack" data-testid="personal-jobbank-workspace">
    <h1>{t('My JobBank')}</h1>
    <p>{t('Find employment opportunities, save jobs and keep track of your applications.')}</p>
    <WorkerExternalJobBank applyNative={workerService.apply} showNativeShortcut={false}/>
  </section>
}
